import React from "react";
import { formatMoney } from "../utils/formatMoney";
import { formatDate } from "../utils/formatDate";
import AuditTrailPage from "../components/AuditTrailPage";
import GiapLaiSeal from "../components/GiapLaiSeal";

function LaborContractPreview({ data, company, signatoryConfig }) {
  const startDateStr = formatDate(data.startDate);
  const endDateStr = formatDate(data.endDate);
  const dobStr = formatDate(data.dob);
  const idDateStr = formatDate(data.idDate);

  // Con dấu mộc đỏ thật của công ty
  const sealImg =
    data?.seal_image ||
    data?.sealImage ||
    signatoryConfig?.sealImage ||
    company?.stampImage ||
    null;

  // Hợp đồng đã ký duyệt và đóng dấu mộc đỏ
  const isManagerStamped = Boolean(
    (data?.stamp_applied || data?.stampApplied || data?.seal_image || data?.sealImage || data?.manager_signature || data?.managerSignature) &&
    sealImg
  );

  return (
    <div
      className="contract-preview-container"
      style={{
        fontFamily: "'Times New Roman', Times, serif",
        fontSize: "13.5px",
        lineHeight: 1.55,
        color: "#111",
        padding: "36px 45px",
        background: "#fff",
      }}
    >
      {/* 1. KHỐI VĂN BẢN HỢP ĐỒNG LAO ĐỘNG */}
      <div id="contract-main-doc" className="contract-main-doc" style={{ background: "#fff" }}>
        
        {/* TRANG 1: Thông tin pháp nhân, bên A, bên B, Điều 1, Điều 2 (KHÔNG có dấu giáp lai) */}
        <div className="contract-page-section" style={{ position: "relative" }}>
          {/* Header */}
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 18 }}>
            <div style={{ textAlign: "center", width: "45%" }}>
              <div style={{ fontWeight: "bold", fontSize: 13, textTransform: "uppercase", lineHeight: 1.3 }}>
                CÔNG TY CỔ PHẦN<br />THƯƠNG MẠI DỊCH VỤ CIS
              </div>
            </div>
            <div style={{ textAlign: "center", width: "52%" }}>
              <div style={{ fontWeight: "bold", fontSize: 13, textTransform: "uppercase" }}>
                CỘNG HÒA XÃ HỘI CHỦ NGHĨA VIỆT NAM
              </div>
              <div style={{ fontWeight: "bold", fontSize: 13 }}>Độc lập – Tự do – Hạnh phúc</div>
              <div style={{ borderTop: "1px solid #111", width: 140, margin: "4px auto 0 auto" }} />
            </div>
          </div>

          {/* Tên HĐ */}
          <div style={{ textAlign: "center", margin: "18px 0" }}>
            <div style={{ fontSize: 17, fontWeight: "bold", textTransform: "uppercase" }}>HỢP ĐỒNG LAO ĐỘNG</div>
            <div style={{ marginTop: 4, fontSize: 13 }}>
              Số: <b>{data.code || "……../HDLD/CIS"}</b>
            </div>
          </div>

          <p style={{ fontStyle: "italic", margin: "4px 0", textAlign: "justify" }}>
            - Căn cứ Bộ luật lao động hiện hành và các văn bản hướng dẫn thi hành
          </p>
          <p style={{ fontStyle: "italic", margin: "4px 0", textAlign: "justify" }}>
            - Căn cứ nhu cầu sử dụng lao động của Công Ty Cổ phần Thương Mại Dịch vụ CIS,
          </p>

          <p style={{ margin: "8px 0", textAlign: "justify" }}>
            Hôm nay, ngày {startDateStr !== "—" && startDateStr !== "___/___/______" ? startDateStr : "…. tháng ….  năm ….."}, tại văn phòng Công Ty Cổ phần Thương Mại Dịch vụ CIS, chúng tôi gồm:
          </p>

          {/* Bên A */}
          <div style={{ marginBottom: 12, textAlign: "justify" }}>
            <div style={{ fontWeight: "bold" }}>
              Một bên là: CÔNG TY CỔ PHẦN THƯƠNG MẠI DỊCH VỤ CIS (Sau đây gọi tắt là người sử dụng lao động hoặc Công ty)
            </div>
            <div>Bà: <b>{company?.representative || "Phạm Thị Thu Lan"}</b></div>
            <div>Số CCCD/Hộ chiếu: <b>{company?.repIdNumber || "034189014297"}</b> cấp ngày <b>{company?.repIdDate || "09/08/2021"}</b></div>
            <div>Chức vụ: <b>{company?.repTitle || "Giám đốc."}</b></div>
            <div>Đại diện cho: <b>{company?.companyName || "Công ty Cổ phần Thương mại dịch vụ CIS"}</b></div>
            <div>Địa chỉ trụ sở chính: {company?.companyAddress || "Tầng 6, số 96 Nguyễn Đình Hoàn, Phường Nghĩa Đô, Quận Cầu Giấy, Thành phố Hà Nội, Việt Nam."}</div>
            <div>Giấy chứng nhận ĐKKD: <b>{company?.certificate || "0110948453"}</b> Ngày cấp: <b>{company?.dateIssued || "04/02/2025"}</b></div>
            <div>Nơi cấp: {company?.issuingAuthority || "Phòng ĐKKD Sở Kế hoạch và Đầu tư Thành phố Hà Nội"}</div>
            <div>Số điện thoại: {company?.phone || "0976567778"}</div>
          </div>

          {/* Bên B */}
          <div style={{ marginBottom: 14, textAlign: "justify" }}>
            <div style={{ fontWeight: "bold" }}>Và một bên là: ÔNG/BÀ: <b>{data.employeeName || "___________________________"}</b></div>
            <div>Sinh ngày: <b>{dobStr && dobStr !== "—" && dobStr !== "___/___/______" ? dobStr : "___________"}</b></div>
            <div>
              Số CCCD/Hộ chiếu: <b>{data.idNumber || "___________"}</b>
              {idDateStr && idDateStr !== "—" && idDateStr !== "___/___/______" ? <> &nbsp;&nbsp;&nbsp;&nbsp; Cấp ngày: <b>{idDateStr}</b></> : null}
              {data.idPlace ? <> tại: <b>{data.idPlace}</b></> : null}
            </div>
            <div>Nơi đăng ký thường trú : {data.address || "___________________________________________"}</div>
            <div>Điện thoại: {data.phone || "___________"}</div>
          </div>

          <p style={{ margin: "8px 0", textAlign: "justify" }}>
            Hai Bên thỏa thuận ký kết hợp đồng lao động này với những điều khoản sau đây:
          </p>

          {/* Điều 1 */}
          <p style={{ fontWeight: "bold", marginTop: 12, marginBottom: 4 }}>
            Điều 1: Loại hợp đồng, chức danh và công việc theo hợp đồng:
          </p>
          <div style={{ paddingLeft: 14, textAlign: "justify" }}>
            <div style={{ marginBottom: 4 }}>
              1.1. Loại hợp đồng lao động:{" "}
              {data.endDate && endDateStr !== "—" && endDateStr !== "___/___/______" ? (
                <>
                  Hợp đồng lao động có thời hạn từ ngày <b>{startDateStr !== "—" && startDateStr !== "___/___/______" ? startDateStr : "…."}</b> đến hết ngày <b>{endDateStr}</b>
                </>
              ) : (
                <>
                  <b>Hợp đồng không xác định thời hạn</b>
                </>
              )}
            </div>
            <div style={{ marginBottom: 4 }}>
              1.2. Chức danh chuyên môn: <b>{data.position || "Nhân viên kinh doanh"}</b>
            </div>
            <div style={{ marginBottom: 4 }}>
              1.3. Công việc phải làm: <b>{data.desc || "Tìm kiếm, phát triển mạng lưới đại lý khách hàng kiểm tra và xử lý"}</b>
            </div>
          </div>

          {/* Điều 2 */}
          <p style={{ fontWeight: "bold", marginTop: 12, marginBottom: 4 }}>
            Điều 2: Địa điểm làm việc, thời giờ làm việc, thời giờ nghỉ ngơi:
          </p>
          <div style={{ paddingLeft: 14, textAlign: "justify" }}>
            <div style={{ marginBottom: 4 }}>
              2.1. Địa điểm làm việc: Làm việc tại văn phòng Công ty phân công. Địa điểm làm việc có thể thay đổi nếu Công ty thay đổi địa chỉ hoặc theo yêu cầu công việc cần điều động người lao động sang địa điểm khác để thực hiện công việc.
            </div>
            <div style={{ marginBottom: 4 }}>
              2.2. Thời giờ làm việc: buổi sáng: 8h00-12h00, buổi chiều: 13h30 -17h30; ngày làm việc từ thứ 2 đến thứ 7. Thời giờ làm việc theo vị trí này có thể được phân bổ linh hoạt theo yêu cầu công việc nhưng phải đảm bảo thời gian làm việc bằng đúng tổng số giờ quy định của Công ty.
            </div>
            <div style={{ marginBottom: 4 }}>
              2.3. Chế độ nghỉ ngơi: Số ngày nghỉ hàng tuần, nghỉ được hưởng nguyên lương (nghỉ lễ, tết, nghỉ hàng tuần, nghi việc riêng được hưởng nguyên lương): Theo quy định của Bộ luật lao động và theo quy định của Công ty. Người lao động được nghỉ việc riêng, nghỉ phép, lao động nữ được nghi thai sản theo quy định của Bộ luật lao động phải có kế hoạch sắp xếp công việc phù hợp để đảm bảo hiệu quả công việc đồng thời phải báo trước cho người sử dụng lao động một khoảng thời gian hợp lý (như hướng dẫn tại sổ tay nhân viên) và được sự đồng ý của người sử dụng lao động (trừ nghỉ việc tang).
            </div>
          </div>
        </div>

        {/* TRANG 2: Điều 3 - Quyền lợi, nghĩa vụ và quyền hạn người lao động (CÓ DẤU GIÁP LAI) */}
        <div
          className="contract-page-section contract-page-break"
          style={{
            pageBreakBefore: "always",
            position: "relative",
            marginTop: 28,
            paddingTop: 20,
            borderTop: "1px dashed #cbd5e1",
          }}
        >
          {/* Dấu giáp lai mép phải trang 2 */}
          <GiapLaiSeal company={company} customStamp={sealImg} data={data} pageNumber={2} visible={isManagerStamped} />

          {/* Điều 3 */}
          <p style={{ fontWeight: "bold", marginTop: 4, marginBottom: 4 }}>
            Điều 3: Quyền lợi, nghĩa vụ và quyền hạn của người lao động
          </p>
          <div style={{ fontWeight: "bold", marginTop: 6, marginBottom: 2 }}>Quyền lợi</div>
          <div style={{ paddingLeft: 14, textAlign: "justify" }}>
            <div style={{ marginBottom: 3 }}>3.1. Phương tiện đi lại làm việc: Do người lao động tự túc.</div>
            <div style={{ marginBottom: 3 }}>3.2. Được cấp đồ dùng văn phòng phẩm và được sử dụng các thiết bị văn phòng vào mục đích công việc</div>
            <div style={{ marginBottom: 3 }}>3.3. Điều kiện an toàn, vệ sinh lao động nơi làm việc theo quy định hiện hành của Nhà nước.</div>
            <div style={{ marginBottom: 3 }}>
              3.4. Mức lương: <b>{data.salary ? `${formatMoney(data.salary)} VNĐ/tháng` : "Mức lương theo thỏa thuận"}</b>
            </div>
            <div style={{ marginBottom: 3 }}>3.5. Các khoản phụ cấp (nếu có) : theo phụ lục dính kèm hợp đồng lao động này.</div>
            <div style={{ marginBottom: 3 }}>3.6. Tiền thưởng : Theo quy định tại Quy chế thưởng do Công ty ban hành tại từng thời điểm.</div>
            <div style={{ marginBottom: 3 }}>3.7. Hình thức trả lương, phụ cấp: Bằng tiền mặt hoặc chuyển khoản trong một lần vào một ngày ấn định trong tháng theo quy định của Công ty. Tiền thưởng được trả bằng tiền mặt hoặc chuyển khoản, thời điểm trả thưởng theo quy định tại Quy chế thưởng do Công ty ban hành tại từng thời điểm.</div>
            <div style={{ marginBottom: 3 }}>3.8. Khen thưởng, đề bạt: Người lao động được khuyến khích bằng vật chất và tinh thần tùy theo hiệu quả sản xuất kinh doanh của Công ty tại từng thời điểm, được tạo cơ hội thăng tiến khi có nhiều thành tích trong công tác, có phẩm chất tốt và tiềm năng phát triển.</div>
            <div style={{ marginBottom: 3 }}>3.9. Được hưởng các chế độ phúc lợi, dãi ngộ khác (tham quan, nghỉ mát hàng năm, cưới hỏi...) do Công ty quy định tại từng thời điểm.</div>
            {data.insurance && <div style={{ marginBottom: 3 }}>3.10. Được tham gia BHXH, BHYT, BHTN theo quy định của Pháp luật.</div>}
          </div>

          <div style={{ fontWeight: "bold", marginTop: 8, marginBottom: 2 }}>Nghĩa vụ</div>
          <div style={{ paddingLeft: 14, textAlign: "justify" }}>
            <div style={{ marginBottom: 3 }}>3.11. Hoàn thành mọi công việc được giao và sẵn sàng chấp nhận mọi sự điều động khi Công ty có yêu cầu.</div>
            <div style={{ marginBottom: 3 }}>3.12. Trong công việc, chịu sự điều hành của người quản lý trực tiếp.</div>
            <div style={{ marginBottom: 3 }}>3.13. Có trách nhiệm báo cáo tiến độ thực hiện và kết quả công việc với quản lý trực tiếp.</div>
            <div style={{ marginBottom: 3 }}>3.14. Nắm rõ và chấp hành nghiêm túc nội quy lao động, các quy chế nội bộ của Công ty, kỷ luật lao động và an toàn, vệ sinh lao động.</div>
            <div style={{ marginBottom: 3 }}>3.15. Nộp đầy đủ hồ sơ cá nhân theo quy định của Công ty trong thời hạn quy định.</div>
            <div style={{ marginBottom: 3 }}>3.16. Bồi thường vật chất khi làm hư hỏng, mất mát tài sản hoặc gây ảnh hưởng nghiêm trọng tới lợi ích của Công ty.</div>
            <div style={{ marginBottom: 3 }}>3.17. Người lao động phải tuân thủ các quy định của Công ty về các thủ tục hành chính, tải chính, kinh doanh, quy định về kiểm soát thông tin, quy định về bảo mật, quy định về chất lượng công việc của Công ty. Nghiêm cấm mọi hành vi lạm dụng tài sản vật chất, thông tin, kiến thức và quan hệ của Công ty để làm lợi cho cá nhân hoặc làm tổn hại đến uy tín và quyền lợi của Công ty.</div>
            <div style={{ marginBottom: 3 }}>3.18. Trong trường hợp chấm dứt quan hệ lao động, người lao động có nghĩa vụ thông báo trước 30 ngày và hoàn thành việc bàn giao/trao trả thanh quyết toán theo quy định của Công ty.</div>
            <div style={{ marginBottom: 3 }}>3.19. Cam kết bảo mật thông tin về tiền lương của người lao động đối với cá nhân và tổ chức khác.</div>
          </div>

          <div style={{ fontWeight: "bold", marginTop: 8, marginBottom: 2 }}>Quyền hạn</div>
          <div style={{ paddingLeft: 14, textAlign: "justify" }}>
            <div style={{ marginBottom: 3 }}>3.20. Có quyền đề xuất về việc thay đổi, tạm hoãn, chấm dứt hợp đồng lao động theo quy định của Bộ luật lao động hiện hành.</div>
            <div style={{ marginBottom: 3 }}>3.21. Nhận lương hàng tháng đúng thời hạn thỏa thuận trong hợp đồng này.</div>
          </div>
        </div>

        {/* TRANG 3: Điều 4, Điều 5, Điều 6 và Khối chữ ký (CÓ DẤU GIÁP LAI) */}
        <div
          className="contract-page-section contract-page-break"
          style={{
            pageBreakBefore: "always",
            position: "relative",
            marginTop: 28,
            paddingTop: 20,
            borderTop: "1px dashed #cbd5e1",
          }}
        >
          {/* Dấu giáp lai mép phải trang 3 */}
          <GiapLaiSeal company={company} customStamp={sealImg} data={data} pageNumber={3} visible={isManagerStamped} />

          {/* Điều 4 */}
          <p style={{ fontWeight: "bold", marginTop: 4, marginBottom: 4 }}>
            Điều 4: Nghĩa vụ và quyền hạn của người sử dụng lao động
          </p>
          <div style={{ fontWeight: "bold", marginTop: 6, marginBottom: 2 }}>Nghĩa vụ</div>
          <div style={{ paddingLeft: 14, textAlign: "justify" }}>
            <div style={{ marginBottom: 3 }}>4.1. Thực hiện đầy đủ những điều kiện cần thiết đã cam kết trong hợp đồng lao động để người lao động làm việc đạt hiệu quả. Bảo đảm việc làm cho người lao động theo hợp đồng đã ký kết.</div>
            <div style={{ marginBottom: 3 }}>4.2. Thanh toán đầy đủ, đúng hạn các chế độ và quyền lợi của người lao động đã cam kết trong hợp đồng lao động và thoả ước lao động tập thể (nếu có).</div>
          </div>

          <div style={{ fontWeight: "bold", marginTop: 8, marginBottom: 2 }}>Quyền hạn</div>
          <div style={{ paddingLeft: 14, textAlign: "justify" }}>
            <div style={{ marginBottom: 3 }}>4.3. Có quyền điều động người lao động hoàn thành công việc theo hợp đồng (bố trí, điều chuyển, tạm ngừng việc…)</div>
            <div style={{ marginBottom: 3 }}>4.4. Có quyền tạm ngừng việc, thay đổi, tạm hoãn, chấm dứt hợp đồng lao động và áp dụng các biện pháp kỷ luật theo quy định của pháp luật và nội quy lao động của Công ty.</div>
            <div style={{ marginBottom: 3 }}>4.5. Có quyền đòi bồi thường, khiếu nại tới các cơ quan có thẩm quyền để bảo vệ quyền lợi của mình nếu người lao động vi phạm Pháp luật Nhà nước hay các điều khoản của hợp đồng này.</div>
            <div style={{ marginBottom: 3 }}>4.6. Ngay tại thời điểm người lao động gửi đơn xin thôi việc hoặc thông báo đơn phương chấm dứt hợp đồng lao động, hoặc bị kỷ luật sa thải, hoặc Công ty thông báo về việc đơn phương chấm dứt hợp đồng lao động, Công ty có quyền thu hồi toàn bộ các tài khoản người dùng (email, timesheet...) và các tài khoản người dùng khác (nếu có) mà Công ty đã cấp cho người lao động sử dụng trong quá trình làm việc tại Công ty ngay lập tức mà không cần thông báo lại hoặc được sự đồng của người lao động.</div>
          </div>

          {/* Điều 5 */}
          <p style={{ fontWeight: "bold", marginTop: 12, marginBottom: 4 }}>
            Điều 5: Thoả thuận khác
          </p>
          <div style={{ paddingLeft: 14, textAlign: "justify" }}>
            <div style={{ marginBottom: 3 }}>5.1. Trong quá trình thực hiện hợp đồng nếu một bên có nhu cầu thay đổi một, một số hoặc toàn bộ nội dung trong hợp đồng phải báo cho bên kia biết ít nhất 03 ngày làm việc để hai bên tiến hành đàm phán, thỏa thuận và ký kết bản phụ lục hợp đồng theo quy định của pháp luật. Trong thời gian tiến hành thoả thuận hai bên vẫn tuân theo hợp đồng lao động đã ký kết.</div>
            <div style={{ marginBottom: 3 }}>5.2. Những vấn đề lao động không ghi trong hợp đồng này thì áp dụng quy định tại Bộ luật lao động hiện hành, thỏa ước lao động tập thể (nếu có) và nội quy lao động của Công ty.</div>
            <div style={{ marginBottom: 3 }}>5.3. Người lao động đã đọc kỹ, hiểu rõ nội dung, tự nguyện ký kết bản hợp đồng này và cam kết thực hiện các điều khoản quy định tại hợp đồng lao động này.</div>
          </div>

          {/* Điều 6 */}
          <p style={{ fontWeight: "bold", marginTop: 12, marginBottom: 4 }}>
            Điều 6: Điều khoản thi hành:
          </p>
          <div style={{ paddingLeft: 14, textAlign: "justify" }}>
            <div style={{ marginBottom: 3 }}>6.1. Hợp đồng lao động này làm tại văn phòng Công ty và có hiệu lực kể từ ngày ký.</div>
            <div style={{ marginBottom: 3 }}>6.2. Phụ lục kèm theo hợp đồng này (nếu có) là một phần không thể tách rời của hợp đồng tạo thành một thể thống nhất và có giá trị như là một điều khoản trong hợp đồng này.</div>
            <div style={{ marginBottom: 3 }}>6.3. Hợp đồng này được lập thành hai (02) bản Tiếng Việt có giá trị pháp lý như nhau, mỗi bên giữ một (01) bản.</div>
          </div>

          {/* Chữ ký 2 bên */}
          <div style={{ display: "flex", justifyContent: "space-between", marginTop: 35, marginBottom: 35, pageBreakInside: "avoid" }}>
            {/* Bên B: Người lao động */}
            <div style={{ textAlign: "center", width: "45%" }}>
              <div style={{ fontWeight: "bold" }}>Người lao động</div>
              <div style={{ fontStyle: "italic", fontSize: 12, marginBottom: 8 }}>(Ký và ghi rõ họ tên)</div>
              
              <div style={{ minHeight: 75, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                {data.employeeSignature ? (
                  <div>
                    <img src={data.employeeSignature} alt="Chữ ký Người lao động" style={{ maxHeight: 65, maxWidth: 180 }} />
                    <div style={{ fontSize: 11, color: "#16a34a", fontWeight: "bold", marginTop: 2 }}>
                      ✓ Đã ký điện tử & xác thực OTP
                    </div>
                    {data.employeeSignedAt && (
                      <div style={{ fontSize: 10, color: "#64748b" }}>
                        {new Date(data.employeeSignedAt).toLocaleString("vi-VN")}
                      </div>
                    )}
                  </div>
                ) : (
                  <div style={{ height: 60 }} />
                )}
              </div>
              
              <div style={{ fontWeight: "bold", marginTop: 6 }}>{data.employeeName || "___________________________"}</div>
            </div>

            {/* Bên A: Người sử dụng lao động */}
            <div style={{ textAlign: "center", width: "45%" }}>
              <div style={{ fontWeight: "bold" }}>Đại diện người sử dụng lao động</div>
              <div style={{ fontStyle: "italic", fontSize: 12, marginBottom: 8 }}>(Ký, đóng dấu)</div>

              <div style={{ minHeight: 75, position: "relative", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                {data.managerSignature ? (
                  <div style={{ position: "relative", display: "inline-block" }}>
                    {/* Chữ ký của Sếp */}
                    <img src={data.managerSignature} alt="Chữ ký Đại diện công ty" style={{ maxHeight: 65, maxWidth: 180, position: "relative", zIndex: 1 }} />
                    
                    {/* Con dấu mộc đỏ trùm 1/3 chữ ký về bên trái */}
                    {isManagerStamped && (
                      <img
                        src={sealImg}
                        alt="Con dấu mộc đỏ công ty"
                        style={{
                          position: "absolute",
                          left: -40,
                          top: -24,
                          width: 105,
                          height: 105,
                          zIndex: 2,
                          opacity: 0.92,
                          transform: "rotate(-8deg)",
                          pointerEvents: "none",
                        }}
                      />
                    )}

                    <div style={{ fontSize: 11, color: "#dc2626", fontWeight: "bold", marginTop: 2, position: "relative", zIndex: 3 }}>
                      ★ Đã ký duyệt & đóng dấu số
                    </div>
                    {data.managerSignedAt && (
                      <div style={{ fontSize: 10, color: "#64748b", position: "relative", zIndex: 3 }}>
                        {new Date(data.managerSignedAt).toLocaleString("vi-VN")}
                      </div>
                    )}
                  </div>
                ) : (
                  <div style={{ height: 60 }} />
                )}
              </div>

              <div style={{ fontWeight: "bold", marginTop: 6 }}>{company?.representative || "Phạm Thị Thu Lan"}</div>
            </div>
          </div>
        </div>
      </div>

      {/* 2. KHỐI BIÊN BẢN CHỨNG NHẬN GIAO KẾT ĐIỆN TỬ (TRANG 4 - CÓ DẤU GIÁP LAI) */}
      {(data.employeeSignature || data.employee_signature || data.managerSignature || data.manager_signature || data.status === "completed" || data.status === "active") && (
        <div id="contract-audit-doc" className="contract-audit-doc" style={{ background: "#fff" }}>
          <AuditTrailPage data={data} company={company} showGiapLai={isManagerStamped} customStamp={sealImg} />
        </div>
      )}
    </div>
  );
}

export default React.memo(LaborContractPreview);
